/*
 * Fecha o painel da busca preditiva do header mobile ao tocar fora dele.
 *
 * PredictiveSearch (assets/predictive-search.js) define onFocusOut(), mas
 * nunca registra o listener: no modal isso não importa, porque o dialog
 * dispara `dialog:close:search`. O campo aberto do header não tem dialog,
 * então sem isto o painel ficaria aberto até o usuário navegar.
 */
(() => {
  const SELECTOR = '.header__mobile-search-predictive';

  document.addEventListener('pointerdown', (event) => {
    document.querySelectorAll(SELECTOR).forEach((instance) => {
      if (!instance.isOpen || typeof instance.close !== 'function') return;
      if (instance.contains(event.target)) return;

      // Sem argumento: fecha o painel mas preserva o termo digitado.
      instance.close();
    });
  });
})();
